import React from 'react';
import EpisodesStep from 'blocks/AutomationWorkflowWizard/components/EpisodesStep/EpisodesStep';
import { EpisodeOption } from 'blocks/AutomationWorkflowWizard/components/EpisodesStep/types';
import { block } from './utils';

export interface AutogramEpisodesStepProps {
  onEpisodeOptionChange: (value: EpisodeOption) => void;
}

const AutogramEpisodesStep: React.FC<AutogramEpisodesStepProps> = ({
  onEpisodeOptionChange,
}: AutogramEpisodesStepProps) => {
  return (
    <div className={block()}>
      <EpisodesStep onClick={onEpisodeOptionChange} />
    </div>
  );
};

export default AutogramEpisodesStep;
